import { memo } from 'react';

import { Settings2Icon } from '@air/design-icons';
import { useBreakpointsContext } from '@air/provider-media-query';

export type FiltersDropdownHeaderProps = {
  title: string;
};

export const FiltersDropdownHeader = memo(({ title }: FiltersDropdownHeaderProps) => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  if (isAboveMediumScreen) {
    return (
      <header
        className="flex h-9 items-center border-b border-b-gray-5 px-3 font-bold text-10 text-gray-10 uppercase tracking-wider"
        data-testid="FILTERS_DROPDOWN_TITLE"
      >
        {title}
      </header>
    );
  }

  return (
    <header
      className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b border-b-gray-4 bg-gray-1 px-4"
      data-testid="FILTERS_DROPDOWN_TITLE"
    >
      <div className="flex size-10 items-center justify-center">
        <Settings2Icon size="lg" className="text-gray-10" />
      </div>
      <span className="font-medium text-18 text-gray-12">Filters</span>
    </header>
  );
});

FiltersDropdownHeader.displayName = 'FiltersDropdownHeader';
